export default __webpack_public_path__ + "static/385-45fda04511b4c25db606850d2c02b979.gif";